module.exports = __webpack_public_path__ + "img/mapTypeBg.a7ad3bad.png";